export default __webpack_public_path__ + "static/media/artichokes.46a93f56.jpg";